export const ACCREDITATION_5_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_logo: "",
    meta_alt_image: "Accreditation logo",
    meta_heading: "NIRF Rank 20",
    meta_description: "Among India's Top Universities- 2024",
    meta_highlight: "",
    meta_heading_color: "#171719",
    meta_description_color: "#373737",
    meta_priority: 1,
    meta_status: true,
  },

  ACCREDITATION_5_FIELDS_CONFIG: [
    {
      fieldName: "background_color",
      label: "Section Background Color",
      value: "#F8F8F8",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Section background",
      required: false,
      defaultValue: "#F8F8F8",
    },
    {
      fieldName: "title_part_1",
      label: "Title — part 1 (primary color)",
      value: "Global",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Global",
      required: false,
      defaultValue: "Global",
    },
    {
      fieldName: "title_part_2",
      label: "Title — part 2 (accent color)",
      value: "Recognition.",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Recognition.",
      required: false,
      defaultValue: "Recognition.",
    },
    {
      fieldName: "title_part_3",
      label: "Title — part 3 (primary color)",
      value: "National",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. National",
      required: false,
      defaultValue: "National",
    },
    {
      fieldName: "title_part_4",
      label: "Title — part 4 (accent color)",
      value: "Pride.",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Pride.",
      required: false,
      defaultValue: "Pride.",
    },
    {
      fieldName: "title_primary_color",
      label: "Title primary text color",
      value: "#171719",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#171719",
      required: false,
      defaultValue: "#171719",
    },
    {
      fieldName: "title_accent_color",
      label: "Title accent text color",
      value: "#E1473F",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#E1473F",
      required: false,
      defaultValue: "#E1473F",
    },
    {
      fieldName: "status",
      label: "Accreditation (cards) status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable section",
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Logo",
      fieldName: "meta_logo",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload logo",
    },
    {
      header: "Logo alt",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Alt text",
    },
    {
      header: "Card title",
      fieldName: "meta_heading",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. NIRF Rank 20",
    },
    {
      header: "Description",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Supporting text",
    },
    {
      header: "Bold line (optional)",
      fieldName: "meta_highlight",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. A+ Grade",
    },
    {
      header: "Card title color",
      fieldName: "meta_heading_color",
      value: "#171719",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#171719",
      defaultValue: "#171719",
    },
    {
      header: "Description color",
      fieldName: "meta_description_color",
      value: "#373737",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#373737",
      defaultValue: "#373737",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Priority",
      required: true,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable item",
      defaultValue: true,
    },
  ],
};
